import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getActivePregnancy } from '../services/authService';
import Tabs from '../components/Tabs';
import HighRiskCases from './HighRiskCases';
import { useSelector } from 'react-redux';
 import Loader from '../components/Loader';
const Antenatal = () => {
  const navigate = useNavigate();
  const [pregnancies, setPregnancies] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [trimesterFilter, setTrimesterFilter] = useState('All Trimesters');
  const [villageFilter, setVillageFilter] = useState('All Villages');
  const [activeTab, setActiveTab] = useState('Active Pregnancies');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
   const [loading, setLoading] = useState(true);
  const perPage = 10;
  const selectedVillageId = useSelector((state) => state.village.selectedVillageId);
  // Fetch data from API
  const fetchPregnancies = async (page = 1) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await getActivePregnancy(page, perPage);
      const result = response || response; // Use response.data if using axios
      console.log('API response:', result);
      if (result.status) {
        setPregnancies(result.data.data || []);
        setTotal(result.data.total || 0);
        setCurrentPage(result.data.currentPage || 1);
        setTotalPages(result.data.totalPages || 1);
      } else {
        console.error('API error:', result.message);
        setError(result.message || 'Failed to fetch data');
      }
    } catch (error) {
      console.error('Fetch error:', error);
      setError('Failed to fetch data. Please try again later.');
    } finally {
      setLoading(false);
          setIsLoading(false);
      
    }
  };

  // Fetch data on mount and when page changes
  useEffect(() => {
    if (activeTab === 'Active Pregnancies') {
      fetchPregnancies(currentPage);
    }
  }, [currentPage, activeTab, selectedVillageId]);

  // Handle ANC form navigation
  const ancFormClick = () => {
    navigate('/anc-register');
  };

  const ancFormvisit = () => {
    navigate('/anc-create');
  };

  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handle search input
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  // Handle filter changes
  const handleTrimesterFilter = (e) => {
    setTrimesterFilter(e.target.value);
  };

  const handleVillageFilter = (e) => {
    setVillageFilter(e.target.value);
  };

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1); // Reset to first page when switching tabs
  };

  // Filter pregnancies based on search, trimester, village
  const filteredPregnancies = pregnancies.filter((pregnancy) => {
    const name = pregnancy?.['Beneficiary.name'] || '';
    const villageName = pregnancy?.['Beneficiary.Village.village_name'] || '';
    const gestationalAge = pregnancy?.['AncVisits.gestational_age'] ?? 0;
    const nextVisitDate = pregnancy?.['AncVisits.next_visit_date'] ?? null;
    const edd = pregnancy?.edd ?? null;
    const matchesSearch = name.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesVillage =
      villageFilter === 'All Villages' || villageName === villageFilter;
    const matchesTrimester =
      trimesterFilter === 'All Trimesters' ||
      (trimesterFilter === '1st Trimester' && gestationalAge <= 12) ||
      (trimesterFilter === '2nd Trimester' &&
        gestationalAge > 12 &&
        gestationalAge <= 24) ||
      (trimesterFilter === '3rd Trimester' && gestationalAge > 24);
   const matchesTab =
      activeTab === 'Active Pregnancies' ||
      (activeTab === 'High Risk Cases' && pregnancy?.risk_status === 'high_risk') ||
      (activeTab === 'Due for ANC Visit' &&
        nextVisitDate &&
        new Date(nextVisitDate) <= new Date()) ||
      (activeTab === 'Delivery Expected' &&
        edd &&
        new Date(edd) <= new Date(new Date().setDate(new Date().getDate() + 30)));

    return matchesSearch && matchesVillage && matchesTrimester && matchesTab;

  });

  // Calculate summary stats with safeguards
  const activePregnanciesCount = pregnancies.length;
  const highRiskCount = pregnancies.filter(
    (p) => p.risk_status === 'high_risk'
  ).length;
  const dueForAncCount = pregnancies.filter(
    (p) =>
      p['AncVisits.next_visit_date'] &&
      new Date(p['AncVisits.next_visit_date']) <= new Date()
  ).length;
  const expectedDeliveriesCount = pregnancies.filter(
    (p) =>
      p.edd &&
      new Date(p.edd) <= new Date(new Date().setDate(new Date().getDate() + 30))
  ).length;
  if (loading) return <Loader />;
          
  return (
    <>
      <div className="page-header">
        <div className="title">Antenatal Care</div>
        <button className="add-button" onClick={ancFormClick}>
          <span className="material-icons icon">add</span>
          New ANC Registration
        </button>
      </div>
      <div className="page-header">
        <button className="add-button" onClick={ancFormvisit}>
          <span className="material-icons icon">add</span>
          New ANC Visit
        </button>
      </div>
     

      <Tabs activeTab={activeTab} onTabChange={handleTabChange} />

      {/* Conditionally render content based on activeTab */}
      {activeTab === 'High Risk Cases' ? (
     <HighRiskCases />
      ) : (
        <>
          <div className="search-filters">
            <div className="search-field">
              <span className="material-icons search-icon">search</span>
              <input
                type="text"
                className="search-input"
                placeholder="Search by name..."
                value={searchQuery}
                onChange={handleSearch}
              />
            </div>
            <select
              className="filter-dropdown"
              value={trimesterFilter}
              onChange={handleTrimesterFilter}
            >
              <option>All Trimesters</option>
              <option>1st Trimester</option>
              <option>2nd Trimester</option>
              <option>3rd Trimester</option>
            </select>
            <select
              className="filter-dropdown"
              value={villageFilter}
              onChange={ handleVillageFilter}
            >
              <option>All Villages</option>
              <option>Rampur</option>
              <option>Ganeshpur</option>
              <option>Shivpura</option>
            </select>
          </div>

          <div className="card-grid">
            <div className="summary-card">
              <div className="headers">
                <div className="icon">
                  <span className="material-icons">pregnant_woman</span>
                </div>
                <div>
                  <div className="count">{activePregnanciesCount}</div>
                  <div className="label">Active Pregnancies</div>
                </div>
              </div>
            </div>
            <div className="summary-card">
              <div className="headers">
                <div className="icon">
                  <span className="material-icons">warning</span>
                </div>
                <div>
                  <div className="count">{highRiskCount}</div>
                  <div className="label">High Risk Cases</div>
                </div>
              </div>
            </div>
            <div className="summary-card">
              <div className="headers">
                <div className="icon">
                  <span className="material-icons">event</span>
                </div>
                <div>
                  <div className="count">{dueForAncCount}</div>
                  <div className="label">Due for ANC Visit</div>
                </div>
              </div>
            </div>
            <div className="summary-card">
              <div className="headers">
                <div className="icon">
                  <span className="material-icons">child_care</span>
                </div>
                <div>
                  <div className="count">{expectedDeliveriesCount}</div>
                  <div className="label">Expected Deliveries (30 days)</div>
                </div>
              </div>
            </div>
          </div>

          <div className="anc-list">
            <div className="list-header">
              <div>Beneficiary</div>
              <div>EDD</div>
              <div>Current Status</div>
              <div>Next ANC Visit</div>
              <div>Actions</div>
            </div>

            {isLoading ? (
              <div>Loading...</div>
            ) : error ? (
              <div className="error">{error}</div>
            ) : filteredPregnancies.length > 0 ? (
              filteredPregnancies.map((pregnancy) => (
                <div className="anc-item" key={pregnancy.tracking_id}>
                  <div className="beneficiary-info">
                    <div className="beneficiary-avatar">
                      <span className="material-icons">pregnant_woman</span>
                    </div>
                    <div>
                      <div className="beneficiary-name">
                        {pregnancy['Beneficiary.name'] || 'Unknown'}
                      </div>
                      <div className="beneficiary-details">
                        {pregnancy['Beneficiary.age'] || 'N/A'} years •{' '}
                        {pregnancy['Beneficiary.Village.village_name'] || 'Unknown'}
                      </div>
                    </div>
                  </div>
                  <div>
                    {pregnancy.edd
                      ? new Date(pregnancy.edd).toLocaleDateString()
                      : 'N/A'}
                  </div>
                  <div>
                    <span
                      className={`status-badge status-${
                        pregnancy.risk_status === 'high_risk'
                          ? 'high-risk'
                          : pregnancy.risk_status === 'normal'
                          ? 'normal'
                          : 'risk'
                      }`}
                    >
                      {pregnancy.risk_status === 'high_risk'
                        ? 'High Risk'
                        : pregnancy.risk_status === 'normal'
                        ? 'Normal'
                        : 'At Risk'}
                    </span>
                    <div className="beneficiary-details">
                      Week {pregnancy['AncVisits.gestational_age'] || 'N/A'} (
                      {(pregnancy['AncVisits.gestational_age'] || 0) <= 12
                        ? '1st Trimester'
                        : (pregnancy['AncVisits.gestational_age'] || 0) <= 24
                        ? '2nd Trimester'
                        : '3rd Trimester'})
                    </div>
                  </div>
                  <div>
                    <div>
                      {pregnancy['AncVisits.next_visit_date']
                        ? new Date(
                            pregnancy['AncVisits.next_visit_date']
                          ).toLocaleDateString()
                        : 'N/A'}
                    </div>
                    <div className="beneficiary-details">
                      ANC Visit {pregnancy['AncVisits.visit_number'] || 'N/A'}
                    </div>
                  </div>
                  <div>
                    <button className="action-button">
                      <span className="material-icons">more_vert</span>
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div>No pregnancies found for the selected filters.</div>
            )}
          </div>

          <div className="pagination">
            <div
              className="page-button"
              onClick={() => handlePageChange(currentPage - 1)}
            >
              <span className="material-icons">chevron_left</span>
            </div>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <div
                key={page}
                className={`page-button ${currentPage === page ? 'active' : ''}`}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </div>
            ))}
            <div
              className="page-button"
              onClick={() => handlePageChange(currentPage + 1)}
            >
              <span className="material-icons">chevron_right</span>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Antenatal;  